import { KnockProvider as KnockProviderBase } from '@knocklabs/react';

import { getConfig } from '@/config';
import { useAuth } from '@/lib/auth';

import { KnockFeedsProvider } from './feeds/knock-feeds-provider';

interface KnockNotificationsProviderProps {
  children: React.ReactNode;
}

/**
 * Authenticated Knock SDK wrapper. Users are synced to Knock using user.id.
 * Feed clients for the notifications bell live in {@link KnockFeedsProvider}.
 */
export const KnockNotificationsProvider = ({
  children,
}: KnockNotificationsProviderProps) => {
  const { user } = useAuth();
  const { knockPublicApiKey } = getConfig();

  if (!user || !knockPublicApiKey) {
    return <>{children}</>;
  }

  return (
    <KnockProviderBase apiKey={knockPublicApiKey} user={{ id: user.id }}>
      <KnockFeedsProvider>{children}</KnockFeedsProvider>
    </KnockProviderBase>
  );
};

/** @deprecated Use {@link KnockNotificationsProvider}. */
export const NotificationsProvider = KnockNotificationsProvider;
